import enhancer from './enhancers'
import LoginForm from './LoginForm'

export default enhancer(LoginForm)
